import { render, staticRenderFns } from "./resizable-common-dialog.vue?vue&type=template&id=80c702d8&scoped=true"
import script from "./resizable-common-dialog.vue?vue&type=script&lang=js"
export * from "./resizable-common-dialog.vue?vue&type=script&lang=js"
import style0 from "./resizable-common-dialog.vue?vue&type=style&index=0&id=80c702d8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c702d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80c702d8')) {
      api.createRecord('80c702d8', component.options)
    } else {
      api.reload('80c702d8', component.options)
    }
    module.hot.accept("./resizable-common-dialog.vue?vue&type=template&id=80c702d8&scoped=true", function () {
      api.rerender('80c702d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/common/dialog/resizable-common-dialog.vue"
export default component.exports